import Footer from "../Footer/Footer";
import "./Home.css";
import RealtyGridSmall from "./RealtyGridSmall";
import SaiBhavanaRealty from "./SaiBhavanaRealty";
import CTASection from "./CTASection";
import HomeValues from "./HomeValues";
import StepProcess from "./stepProcess";
import Testimonials from "./Testimonals";

function Home(){
    return(
        <>
        <div className="home">
            <SaiBhavanaRealty />
            <HomeValues />
            <StepProcess />
            <CTASection />
            <Testimonials />
            <RealtyGridSmall />
        </div>
        </>
    )
}

export default Home;